export default [
  'Shearing',
  'Stamping',
  'Forming',
  'Water-jet cutting',
];
